export const THRESHOLD_TIME = 10; // seconds
export const SKIP_INTO = 'Skip Intro';
export const WATCH_CREDITS = 'Watch Credits';
export const NEXT_EPISODE = 'Next Episode';
